/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  RouteFieldTesterSuggestionDTO,
  RoutePlanActionResultDTO,
  RoutePlanApplyRequestDTO,
  RoutePlanConfirmRebookingRequestDTO,
  RoutePlanDeclineRebookingRequestDTO,
  RoutePlanEvaluateFieldTesterRequestDTO,
  RoutePlanEvaluatePackageRequestDTO,
  RoutePlanEvaluatePackageResultDTO,
  RoutePlanFeedbackRequestDTO,
  RoutePlanPreviewRequestDTO,
  RoutePlanProposalDTO,
  RoutePlanRebookingResultDTO,
  RoutePlanReserveAssignmentRequestDTO,
  RoutePlanningCountyDTO,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useRoutePlanningCountiesHook = () => {
  const routePlanningCounties = useCustomInstance<RoutePlanningCountyDTO[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return routePlanningCounties({
        url: `/api/RoutePlanning/Counties`,
        method: 'GET',
        signal,
      });
    },
    [routePlanningCounties]
  );
};

export const getRoutePlanningCountiesQueryKey = () => {
  return [`/api/RoutePlanning/Counties`] as const;
};

export const useRoutePlanningCountiesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useRoutePlanningCountiesHook>>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanningCountiesHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRoutePlanningCountiesQueryKey();

  const routePlanningCounties = useRoutePlanningCountiesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanningCountiesHook>>>
  > = ({ signal }) => routePlanningCounties(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanningCountiesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RoutePlanningCountiesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanningCountiesHook>>>
>;
export type RoutePlanningCountiesQueryError = unknown;

export const useRoutePlanningCounties = <
  TData = Awaited<ReturnType<ReturnType<typeof useRoutePlanningCountiesHook>>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanningCountiesHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useRoutePlanningCountiesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useRoutePlanningPreviewHook = () => {
  const routePlanningPreview = useCustomInstance<RoutePlanProposalDTO>();

  return useCallback(
    (routePlanPreviewRequestDTO: RoutePlanPreviewRequestDTO) => {
      return routePlanningPreview({
        url: `/api/RoutePlanning/Preview`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: routePlanPreviewRequestDTO,
      });
    },
    [routePlanningPreview]
  );
};

export const useRoutePlanningPreviewMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanningPreviewHook>>>,
    TError,
    { data: RoutePlanPreviewRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanningPreviewHook>>>,
  TError,
  { data: RoutePlanPreviewRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const routePlanningPreview = useRoutePlanningPreviewHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanningPreviewHook>>>,
    { data: RoutePlanPreviewRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return routePlanningPreview(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RoutePlanningPreviewMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanningPreviewHook>>>
>;
export type RoutePlanningPreviewMutationBody = RoutePlanPreviewRequestDTO;
export type RoutePlanningPreviewMutationError = unknown;

export const useRoutePlanningPreview = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanningPreviewHook>>>,
    TError,
    { data: RoutePlanPreviewRequestDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanningPreviewHook>>>,
  TError,
  { data: RoutePlanPreviewRequestDTO },
  TContext
> => {
  const mutationOptions = useRoutePlanningPreviewMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useRoutePlanningEvaluateFieldTesterHook = () => {
  const routePlanningEvaluateFieldTester =
    useCustomInstance<RouteFieldTesterSuggestionDTO>();

  return useCallback(
    (
      routePlanEvaluateFieldTesterRequestDTO: RoutePlanEvaluateFieldTesterRequestDTO
    ) => {
      return routePlanningEvaluateFieldTester({
        url: `/api/RoutePlanning/EvaluateFieldTester`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: routePlanEvaluateFieldTesterRequestDTO,
      });
    },
    [routePlanningEvaluateFieldTester]
  );
};

export const useRoutePlanningEvaluateFieldTesterMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useRoutePlanningEvaluateFieldTesterHook>>
    >,
    TError,
    { data: RoutePlanEvaluateFieldTesterRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useRoutePlanningEvaluateFieldTesterHook>>
  >,
  TError,
  { data: RoutePlanEvaluateFieldTesterRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const routePlanningEvaluateFieldTester =
    useRoutePlanningEvaluateFieldTesterHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useRoutePlanningEvaluateFieldTesterHook>>
    >,
    { data: RoutePlanEvaluateFieldTesterRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return routePlanningEvaluateFieldTester(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RoutePlanningEvaluateFieldTesterMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useRoutePlanningEvaluateFieldTesterHook>>
  >
>;
export type RoutePlanningEvaluateFieldTesterMutationBody =
  RoutePlanEvaluateFieldTesterRequestDTO;
export type RoutePlanningEvaluateFieldTesterMutationError = unknown;

export const useRoutePlanningEvaluateFieldTester = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useRoutePlanningEvaluateFieldTesterHook>>
    >,
    TError,
    { data: RoutePlanEvaluateFieldTesterRequestDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useRoutePlanningEvaluateFieldTesterHook>>
  >,
  TError,
  { data: RoutePlanEvaluateFieldTesterRequestDTO },
  TContext
> => {
  const mutationOptions =
    useRoutePlanningEvaluateFieldTesterMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useRoutePlanningReserveForManualPlanningHook = () => {
  const routePlanningReserveForManualPlanning = useCustomInstance<boolean>();

  return useCallback(
    (
      routePlanReserveAssignmentRequestDTO: RoutePlanReserveAssignmentRequestDTO
    ) => {
      return routePlanningReserveForManualPlanning({
        url: `/api/RoutePlanning/ReserveForManualPlanning`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: routePlanReserveAssignmentRequestDTO,
      });
    },
    [routePlanningReserveForManualPlanning]
  );
};

export const useRoutePlanningReserveForManualPlanningMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useRoutePlanningReserveForManualPlanningHook>
      >
    >,
    TError,
    { data: RoutePlanReserveAssignmentRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useRoutePlanningReserveForManualPlanningHook>>
  >,
  TError,
  { data: RoutePlanReserveAssignmentRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const routePlanningReserveForManualPlanning =
    useRoutePlanningReserveForManualPlanningHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useRoutePlanningReserveForManualPlanningHook>
      >
    >,
    { data: RoutePlanReserveAssignmentRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return routePlanningReserveForManualPlanning(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RoutePlanningReserveForManualPlanningMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useRoutePlanningReserveForManualPlanningHook>>
  >
>;
export type RoutePlanningReserveForManualPlanningMutationBody =
  RoutePlanReserveAssignmentRequestDTO;
export type RoutePlanningReserveForManualPlanningMutationError = unknown;

export const useRoutePlanningReserveForManualPlanning = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useRoutePlanningReserveForManualPlanningHook>
      >
    >,
    TError,
    { data: RoutePlanReserveAssignmentRequestDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useRoutePlanningReserveForManualPlanningHook>>
  >,
  TError,
  { data: RoutePlanReserveAssignmentRequestDTO },
  TContext
> => {
  const mutationOptions =
    useRoutePlanningReserveForManualPlanningMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useRoutePlanningConfirmRebookingHook = () => {
  const routePlanningConfirmRebooking =
    useCustomInstance<RoutePlanRebookingResultDTO>();

  return useCallback(
    (
      routePlanConfirmRebookingRequestDTO: RoutePlanConfirmRebookingRequestDTO
    ) => {
      return routePlanningConfirmRebooking({
        url: `/api/RoutePlanning/ConfirmRebooking`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: routePlanConfirmRebookingRequestDTO,
      });
    },
    [routePlanningConfirmRebooking]
  );
};

export const useRoutePlanningConfirmRebookingMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useRoutePlanningConfirmRebookingHook>>
    >,
    TError,
    { data: RoutePlanConfirmRebookingRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanningConfirmRebookingHook>>>,
  TError,
  { data: RoutePlanConfirmRebookingRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const routePlanningConfirmRebooking = useRoutePlanningConfirmRebookingHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useRoutePlanningConfirmRebookingHook>>
    >,
    { data: RoutePlanConfirmRebookingRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return routePlanningConfirmRebooking(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RoutePlanningConfirmRebookingMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanningConfirmRebookingHook>>>
>;
export type RoutePlanningConfirmRebookingMutationBody =
  RoutePlanConfirmRebookingRequestDTO;
export type RoutePlanningConfirmRebookingMutationError = unknown;

export const useRoutePlanningConfirmRebooking = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useRoutePlanningConfirmRebookingHook>>
    >,
    TError,
    { data: RoutePlanConfirmRebookingRequestDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanningConfirmRebookingHook>>>,
  TError,
  { data: RoutePlanConfirmRebookingRequestDTO },
  TContext
> => {
  const mutationOptions =
    useRoutePlanningConfirmRebookingMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useRoutePlanningDeclineRebookingHook = () => {
  const routePlanningDeclineRebooking = useCustomInstance<boolean>();

  return useCallback(
    (
      routePlanDeclineRebookingRequestDTO: RoutePlanDeclineRebookingRequestDTO
    ) => {
      return routePlanningDeclineRebooking({
        url: `/api/RoutePlanning/DeclineRebooking`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: routePlanDeclineRebookingRequestDTO,
      });
    },
    [routePlanningDeclineRebooking]
  );
};

export const useRoutePlanningDeclineRebookingMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useRoutePlanningDeclineRebookingHook>>
    >,
    TError,
    { data: RoutePlanDeclineRebookingRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanningDeclineRebookingHook>>>,
  TError,
  { data: RoutePlanDeclineRebookingRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const routePlanningDeclineRebooking = useRoutePlanningDeclineRebookingHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useRoutePlanningDeclineRebookingHook>>
    >,
    { data: RoutePlanDeclineRebookingRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return routePlanningDeclineRebooking(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RoutePlanningDeclineRebookingMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanningDeclineRebookingHook>>>
>;
export type RoutePlanningDeclineRebookingMutationBody =
  RoutePlanDeclineRebookingRequestDTO;
export type RoutePlanningDeclineRebookingMutationError = unknown;

export const useRoutePlanningDeclineRebooking = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useRoutePlanningDeclineRebookingHook>>
    >,
    TError,
    { data: RoutePlanDeclineRebookingRequestDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanningDeclineRebookingHook>>>,
  TError,
  { data: RoutePlanDeclineRebookingRequestDTO },
  TContext
> => {
  const mutationOptions =
    useRoutePlanningDeclineRebookingMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useRoutePlanningEvaluatePackageHook = () => {
  const routePlanningEvaluatePackage =
    useCustomInstance<RoutePlanEvaluatePackageResultDTO>();

  return useCallback(
    (
      routePlanEvaluatePackageRequestDTO: RoutePlanEvaluatePackageRequestDTO
    ) => {
      return routePlanningEvaluatePackage({
        url: `/api/RoutePlanning/EvaluatePackage`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: routePlanEvaluatePackageRequestDTO,
      });
    },
    [routePlanningEvaluatePackage]
  );
};

export const useRoutePlanningEvaluatePackageMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanningEvaluatePackageHook>>>,
    TError,
    { data: RoutePlanEvaluatePackageRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanningEvaluatePackageHook>>>,
  TError,
  { data: RoutePlanEvaluatePackageRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const routePlanningEvaluatePackage = useRoutePlanningEvaluatePackageHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanningEvaluatePackageHook>>>,
    { data: RoutePlanEvaluatePackageRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return routePlanningEvaluatePackage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RoutePlanningEvaluatePackageMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanningEvaluatePackageHook>>>
>;
export type RoutePlanningEvaluatePackageMutationBody =
  RoutePlanEvaluatePackageRequestDTO;
export type RoutePlanningEvaluatePackageMutationError = unknown;

export const useRoutePlanningEvaluatePackage = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanningEvaluatePackageHook>>>,
    TError,
    { data: RoutePlanEvaluatePackageRequestDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanningEvaluatePackageHook>>>,
  TError,
  { data: RoutePlanEvaluatePackageRequestDTO },
  TContext
> => {
  const mutationOptions =
    useRoutePlanningEvaluatePackageMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useRoutePlanningApplyHook = () => {
  const routePlanningApply = useCustomInstance<RoutePlanActionResultDTO[]>();

  return useCallback(
    (routePlanApplyRequestDTO: RoutePlanApplyRequestDTO) => {
      return routePlanningApply({
        url: `/api/RoutePlanning/Apply`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: routePlanApplyRequestDTO,
      });
    },
    [routePlanningApply]
  );
};

export const useRoutePlanningApplyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanningApplyHook>>>,
    TError,
    { data: RoutePlanApplyRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanningApplyHook>>>,
  TError,
  { data: RoutePlanApplyRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const routePlanningApply = useRoutePlanningApplyHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanningApplyHook>>>,
    { data: RoutePlanApplyRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return routePlanningApply(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RoutePlanningApplyMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanningApplyHook>>>
>;
export type RoutePlanningApplyMutationBody = RoutePlanApplyRequestDTO;
export type RoutePlanningApplyMutationError = unknown;

export const useRoutePlanningApply = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanningApplyHook>>>,
    TError,
    { data: RoutePlanApplyRequestDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanningApplyHook>>>,
  TError,
  { data: RoutePlanApplyRequestDTO },
  TContext
> => {
  const mutationOptions = useRoutePlanningApplyMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useRoutePlanningSendFeedbackHook = () => {
  const routePlanningSendFeedback = useCustomInstance<boolean>();

  return useCallback(
    (routePlanFeedbackRequestDTO: RoutePlanFeedbackRequestDTO) => {
      return routePlanningSendFeedback({
        url: `/api/RoutePlanning/SendFeedback`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: routePlanFeedbackRequestDTO,
      });
    },
    [routePlanningSendFeedback]
  );
};

export const useRoutePlanningSendFeedbackMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanningSendFeedbackHook>>>,
    TError,
    { data: RoutePlanFeedbackRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanningSendFeedbackHook>>>,
  TError,
  { data: RoutePlanFeedbackRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const routePlanningSendFeedback = useRoutePlanningSendFeedbackHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanningSendFeedbackHook>>>,
    { data: RoutePlanFeedbackRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return routePlanningSendFeedback(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RoutePlanningSendFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanningSendFeedbackHook>>>
>;
export type RoutePlanningSendFeedbackMutationBody = RoutePlanFeedbackRequestDTO;
export type RoutePlanningSendFeedbackMutationError = unknown;

export const useRoutePlanningSendFeedback = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanningSendFeedbackHook>>>,
    TError,
    { data: RoutePlanFeedbackRequestDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanningSendFeedbackHook>>>,
  TError,
  { data: RoutePlanFeedbackRequestDTO },
  TContext
> => {
  const mutationOptions = useRoutePlanningSendFeedbackMutationOptions(options);

  return useMutation(mutationOptions);
};
